import { render, staticRenderFns } from "./pullNew.vue?vue&type=template&id=3bc3387c&scoped=true&"
import script from "./pullNew.vue?vue&type=script&lang=js&"
export * from "./pullNew.vue?vue&type=script&lang=js&"
import style0 from "./pullNew.vue?vue&type=style&index=0&id=3bc3387c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc3387c",
  null
  
)

export default component.exports